/* eslint-disable import/prefer-default-export */
import type {
  ResourceTypeEnum,
  RouteInfo
} from '@src/endpoints/services/commonHdr.service'
import type {
  NetInstanceInfo,
  NetSgInfo,
  NetSubnetInfo
} from '@src/endpoints/services/graphQueryMgr.service'

export interface CommonNetInfo {
  type?: ResourceTypeEnum
  region_name?: string
}

export interface InstanceInfo extends NetInstanceInfo, CommonNetInfo {}
export interface SGInfo extends NetSgInfo, CommonNetInfo {}
export interface SubnetInfo extends NetSubnetInfo, CommonNetInfo {}
export interface RoutesInfo extends RouteInfo {}
export interface SGRulesInfo {
  IPv4Range?: string
  Description?: string
  Protocol?: string
  IPv6Range?: string
  Number?: string
  Direction?: string
}

// Reducer
export const defaultState = {
  instanceInfoList: [] as InstanceInfo[],
  sgInfoList: [] as SGInfo[],
  subnetInfoList: [] as SubnetInfo[],
  sgRulesInfoList: [] as SGRulesInfo[],
  routesInfoList: [] as RouteInfo[]
}

export type NetworksState = typeof defaultState
